export default __webpack_public_path__ + "static/media/database-solid.eab3842b.svg";